import React from 'react';
import { Loader2 } from 'lucide-react';

const variantStyles = {
  primary:
    'bg-buttonBg text-buttonTxt border border-buttonBg hover:bg-buttonHoverBg hover:border-buttonHoverBg focus:ring-brand/30',
  secondary:
    'bg-white text-buttonBg border border-buttonBg hover:bg-brand-light focus:ring-brand/30',
  danger:
    'bg-danger text-white border border-danger hover:bg-red-600 focus:ring-red-300',
  success:
    'bg-success text-white border border-success hover:bg-emerald-600 focus:ring-emerald-300',
  outline:
    'bg-transparent text-secondary border border-gray-300 hover:bg-gray-50 focus:ring-gray-200',
  ghost:
    'bg-transparent text-secondary border border-transparent hover:bg-gray-100 focus:ring-gray-200',
};

const sizeStyles = {
  sm: 'px-3 py-1.5 text-xs gap-1.5',
  md: 'px-4 py-2 text-sm gap-2',
  lg: 'px-6 py-2.5 text-base gap-2',
};

const Button = ({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  children,
  onClick,
  disabled = false,
  loading = false,
  type = 'button',
  className = '',
  ...props
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={`
        inline-flex items-center justify-center font-medium rounded-btn
        transition-all duration-200 focus:outline-none focus:ring-2
        disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap
        ${variantStyles[variant] || variantStyles.primary}
        ${sizeStyles[size] || sizeStyles.md}
        ${className}
      `}
      {...props}
    >
      {loading && <Loader2 className="w-4 h-4 animate-spin shrink-0" />}
      {!loading && Icon && iconPosition === 'left' && <Icon className="w-4 h-4 shrink-0" />}
      {children && <span className="inline-flex items-center gap-1.5">{children}</span>}
      {!loading && Icon && iconPosition === 'right' && <Icon className="w-4 h-4 shrink-0" />}
    </button>
  );
};

export default Button;
